var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdTime08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTime08",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 33.437,
    viewBox: "0 0 31.5 33.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-forward-ten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M27.5,2.5V6.7A15,15,0,1,0,15,30V27.5A12.5,12.5,0,1,1,25.829,8.75H21.248v2.5H27.5A2.5,2.5,0,0,0,30,8.75V2.5Z",
    transform: "translate(-0.002 0.001)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M14.5,14.75H7v-2.5h5V6h2.5Z",
    transform: "translate(1.747 1.501)",
    fill: "#b7b7b7"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(18.5 29.437)",
    fill: "#b7b7b7",
    fontSize: 20,
    fontFamily: "TTDongwhacaekR, '\\\\\\\\32 10 Dongwhacaek'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime08);
export default __webpack_public_path__ + "static/media/prodTime08.5080434f727a18c3e5ff447eb3405ce6.svg";
export { ForwardRef as ReactComponent };